import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import 'prop-types';
import { jsx } from '@emotion/core';
import AccentBar from '../AccentBar/AccentBar.js';
import { textAlignCenter } from '../../styles/text/textAlignCenter.js';
import cardStyles from '../../styles/card.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Card = function Card(_ref) {
  var accentBarBg = _ref.accentBarBg,
      type = _ref.type,
      children = _ref.children,
      showAccentBar = _ref.showAccentBar,
      theme = _ref.theme,
      otherProps = _objectWithoutProperties(_ref, ["accentBarBg", "type", "children", "showAccentBar", "theme"]);

  var cardStyleObject = _objectSpread({}, cardStyles.card);

  var cardTypeStyleObject;

  switch (type) {
    case 'special':
      cardTypeStyleObject = _objectSpread(_objectSpread(_objectSpread({}, cardStyles.cardFlex), textAlignCenter), {}, {
        '> div': cardStyles.cardRelative___div
      });
      break;

    case 'standard':
    default:
      cardTypeStyleObject = {};
      break;
  }

  var styleObject = _objectSpread(_objectSpread({}, cardStyleObject), cardTypeStyleObject);

  return jsx("div", _extends({
    css: theme
  }, otherProps), jsx("div", {
    css: styleObject
  }, showAccentBar && jsx(AccentBar, {
    theme: accentBarBg
  }), children));
};

Card.defaultProps = {
  accentBarBg: {},
  type: 'standard',
  children: null,
  showAccentBar: false,
  theme: undefined
};

export default Card;
